import { IOnInit } from "angular";
import { Record } from "../../../records/server/crud";
import { ContractTypeService } from "../ContractService";

export class ContractDetailComponentController implements IOnInit {
  contract!: Record;
  contractType!: ContractTypeService;

  static $inject = [];
  constructor() {}

  $onInit(): void {}
}
